import { cn } from '@core/utils';
import { useContext } from 'react';

import type { HTMLTagProps } from '../../../../types';
import { BottomDrawerContext } from '..';

type BottomDrawerHandleWrapperProps = HTMLTagProps<'div'>;

export const HandleWrapper = ({
  children,
  className,
  ...restProps
}: BottomDrawerHandleWrapperProps) => {
  const context = useContext(BottomDrawerContext);

  if (!context)
    throw new Error(
      'BottomDrawer.HandleWrapper는 BottomDrawer 내부에서만 사용할 수 있습니다.',
    );

  return context.onClose ? (
    <div
      {...restProps}
      {...context.swipeableHandlers}
      className={cn(
        'relative flex w-full justify-center px-8 pb-12 pt-8',
        className,
      )}
    >
      {children}
    </div>
  ) : (
    <div className="relative h-36 w-full" />
  );
};
